/**
 * This file is for the up/down/enter controls for all autocomplete types
 */

window.AutoCompleteArrowControls = new function()
{
    this.init = function() {
        document.onkeydown = function(e) {
            if($('input.user-page-posts').is(":focus")) { /*User Page Post Autocomplete*/
                switch(e.which) {
                    case 40: // down
                        jQuery('input.user-page-posts').next('.user-page-post-autocomplete').find('li:first-child > a').focus();
                    break;

                    case 27: //escape
                        jQuery('.user-page-post-autocomplete').empty();
                    break;

                    default: return;
                }
                e.preventDefault();
            } else if($('.user-page-post-autocomplete a').is(":focus")) {
                switch(e.which) {
                    case 38: // up
                        if(jQuery('.user-page-post-autocomplete a:focus').parent().prev().find('a').length) {
                            jQuery('.user-page-post-autocomplete a:focus').parent().prev().find('a').focus();
                        } else {
                            jQuery('input.user-page-posts').focus();
                        }
                    break;

                    case 40: // down
                        jQuery('.user-page-post-autocomplete a:focus').parent().next().find('a').focus();
                    break;

                    default: return;
                }                    
                e.preventDefault();
            } else if($('input.page-builder-posts').is(":focus")) { /*User Page Post Autocomplete*/
                switch(e.which) {
                    case 40: // down
                        jQuery('input.page-builder-posts').next('.page-builder-post-autocomplete').find('li:first-child > a').focus();
                    break;

                    case 27: //escape
                        jQuery('.page-builder-post-autocomplete').empty();
                    break;

                    default: return;
                }
                e.preventDefault();
            } else if($('.page-builder-post-autocomplete a').is(":focus")) {
                switch(e.which) {
                    case 38: // up
                        if(jQuery('.page-builder-post-autocomplete a:focus').parent().prev().find('a').length) {
                            jQuery('.page-builder-post-autocomplete a:focus').parent().prev().find('a').focus();
                        } else {
                            jQuery('input.page-builder-posts').focus();
                        }
                    break;

                    case 40: // down
                        jQuery('.page-builder-post-autocomplete a:focus').parent().next().find('a').focus();
                    break;

                    default: return;
                }                    
                e.preventDefault();
            }
        };
    };
}

jQuery(document).ready(function($) {
    AutoCompleteArrowControls.init();
});
